/**
 * Transforms a single question paper item to the GraphQL node format
 */
export function mapQPToNode(item) {
    return {
        id: item.id,
        data: item.data,
        type: item.type,
        ctime: item.ctime,
        utime: item.utime,
    };
}
/**
 * Transforms a paginated list of question papers to the GraphQL format
 */
export function mapPaginatedQPs(result) {
    return {
        totalCount: result?.totalCount ?? 0,
        list: result?.list.map(mapQPToNode) ?? [],
    };
}
